export function lookForChangesInContact(original, current) {
  return (
    original.name === current.name &&
    original.email === current.email &&
    original.position === current.position &&
    original.phone_number === current.phone_number &&
    original.usergroup === current.usergroup_id
  );
}